export default __webpack_public_path__ + "9a2d95c17dcdc16ff41fca4d19fa5489.png";